<div class="body">

    <mat-toolbar class="ams-toolbar">

        <button mat-icon-button>
            <mat-icon>filter_alt</mat-icon>
        </button>

        <span>{{ userFilterIdentifier? 'Bestehenden Nutzerfilter anpassen': 'Neuen Nutzerfilter hinzufügen' }}</span>
        <span class="spacer"></span>

        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>

    </mat-toolbar>

    <div class="content">

        <mat-tab-group (selectedTabChange)="tabChanged($event)">

            <ng-container *ngFor="let step of steps">

                <mat-tab [label]="step.label"></mat-tab>

            </ng-container>

        </mat-tab-group>

        <div class="dynamic-content-wrapper">

            <ng-container #dynamicInner></ng-container>

        </div>

    </div>

    <div class="footer">

        <button mat-raised-button color="primary" (click)="saveFilter()">Speichern</button>

    </div>

</div>
